import ServiceBase from '../../ServiceBase';
import newsProxy from './../../../proxies/market/watchlist/NewsProxy';

class NewsService extends ServiceBase {
  getListWatchListNews(params, source) {
    return this.getData(() => newsProxy.getListWatchListNews(params, source));
  }
}

const newsService = new NewsService();
export default newsService;
